import React from 'react'
import user1 from './images/BUY.png'
import user2 from './images/rent.png'
import user3 from './images/sell.png'
import './Testimonials.css'

const Testimonials = () => {
    return (
        <div className='testimonials' id='testimonials'>
            <div className='container'>
                <h2>Services</h2>
                <span className='line'></span>
                <div className='content'>
                        <div className='card'>
                        <img  className="serimg" src={user1} alt='user1'/>
                        <h1>BUY</h1>
                        <p>we simplify the property buying process for you. Our experienced agents are dedicated to helping you find the perfect property that meets your needs and budget. From initial search to final closing, we provide comprehensive support every step of the way.</p>
                        
                    </div>
                    <div className='card'>
                        <img className="serimg" src={user2} alt='user1'/>
                        <h1>RENT</h1>
                        <p>Finding the right rental property is easy with BSJ Real Estate agency. We offer a wide range of rental properties to suit your needs, whether you're looking for a cozy apartment or a spacious house.</p>
                    </div>
                    <div className='card'>
                        <img className="serimg" src={user3} alt='user1'/>
                        <h1>SELL</h1>
                        <p>Sell your property with confidence through BSJ Real Estate agency. Our expert team is here to help you get the best price for your property in the shortest time possible.</p>
                    </div>
                  
                </div>
            </div>
        </div>
    )
}

export default Testimonials
